import React from "react";
import { VOLCAN_MENU_ICONS } from "./volcanMenuIcons";
import "./SectionTitleIcon.css";

export default function SectionTitleIcon({ sectionKey }) {
  const src = VOLCAN_MENU_ICONS[sectionKey];
  if (!src) return null;

  return (
    <div className="sgc-section-title__icon" aria-hidden>
      <img src={src} alt="" className="sgc-section-title__icon-img" />
    </div>
  );
}
